import * as _4 from 'lodash4';
import { APProgramSlot } from '../builders/ap_program_slot_builder';
import { IAPAPMarkAsMetStatusDatasource } from '../components/mark_as_met/datasources/mark_as_met_status_datasource';
import { APProgramSlotServant } from '../servants/ap_program_slot_servant';

export class APProgramSlotHelper {
  constructor(private ngAPMarkAsMetStatusDatasource: IAPAPMarkAsMetStatusDatasource) {}

  isMarkedAsMet(programSlot: APProgramSlot): boolean {
    const metEntry = this.ngAPMarkAsMetStatusDatasource.query((slot) => slot.program_slot === programSlot.id);
    return !_4.isEmpty(metEntry) || APProgramSlotServant.isProgramSlotMET(programSlot);
  }
}

angular.module('capability-ng-academic-planner').service('ngAPProgramSlotHelper', APProgramSlotHelper);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/helpers/program_slot_helper.ts